import styles from '@/shared/ui/ui-kit.module.css';

type EmptyStateProps = {
  title: string;
  description?: string;
  plain?: boolean;
};

export function EmptyState({ title, description, plain = false }: EmptyStateProps): JSX.Element {
  return (
    <div className={plain ? styles.simpleEmptyState : `${styles.emptyState} ${styles.pageFrame}`}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      {description ? <p className={styles.sectionDescription}>{description}</p> : null}
    </div>
  );
}
